const cp437 =
	'' +
	'\u0000\u263A\u263B\u2665\u2666\u2663\u2660\u2022' +
	'\u25D8\u25CB\u25D9\u2642\u2640\u266A\u266B\u263C' +
	'\u25BA\u25C4\u2195\u203C\u00B6\u00A7\u25AC\u21A8' +
	'\u2191\u2193\u2192\u2190\u221F\u2194\u25B2\u25BC' +
	'\u0020\u0021\u0022\u0023\u0024\u0025\u0026\u0027' +
	'\u0028\u0029\u002A\u002B\u002C\u002D\u002E\u002F' +
	'\u0030\u0031\u0032\u0033\u0034\u0035\u0036\u0037' +
	'\u0038\u0039\u003A\u003B\u003C\u003D\u003E\u003F' +
	'\u0040\u0041\u0042\u0043\u0044\u0045\u0046\u0047' +
	'\u0048\u0049\u004A\u004B\u004C\u004D\u004E\u004F' +
	'\u0050\u0051\u0052\u0053\u0054\u0055\u0056\u0057' +
	'\u0058\u0059\u005A\u005B\u005C\u005D\u005E\u005F' +
	'\u0060\u0061\u0062\u0063\u0064\u0065\u0066\u0067' +
	'\u0068\u0069\u006A\u006B\u006C\u006D\u006E\u006F' +
	'\u0070\u0071\u0072\u0073\u0074\u0075\u0076\u0077' +
	'\u0078\u0079\u007A\u007B\u007C\u007D\u007E\u2302' +
	'\u00C7\u00FC\u00E9\u00E2\u00E4\u00E0\u00E5\u00E7' +
	'\u00EA\u00EB\u00E8\u00EF\u00EE\u00EC\u00C4\u00C5' +
	'\u00C9\u00E6\u00C6\u00F4\u00F6\u00F2\u00FB\u00F9' +
	'\u00FF\u00D6\u00DC\u00A2\u00A3\u00A5\u20A7\u0192' +
	'\u00E1\u00ED\u00F3\u00FA\u00F1\u00D1\u00AA\u00BA' +
	'\u00BF\u2310\u00AC\u00BD\u00BC\u00A1\u00AB\u00BB' +
	'\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556' +
	'\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510' +
	'\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F' +
	'\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567' +
	'\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B' +
	'\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580' +
	'\u03B1\u00DF\u0393\u03C0\u03A3\u03C3\u00B5\u03C4' +
	'\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229' +
	'\u2261\u00B1\u2265\u2264\u2320\u2321\u00F7\u2248' +
	'\u00B0\u2219\u00B7\u221A\u207F\u00B2\u25A0\u0020';

const cp1252 =
	'' +
	'\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007' +
	'\u0008\u0009\u000A\u000B\u000C\u000D\u000E\u000F' +
	'\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017' +
	'\u0018\u0019\u001A\u001B\u001C\u001D\u001E\u001F' +
	'\u0020\u0021\u0022\u0023\u0024\u0025\u0026\u0027' +
	'\u0028\u0029\u002A\u002B\u002C\u002D\u002E\u002F' +
	'\u0030\u0031\u0032\u0033\u0034\u0035\u0036\u0037' +
	'\u0038\u0039\u003A\u003B\u003C\u003D\u003E\u003F' +
	'\u0040\u0041\u0042\u0043\u0044\u0045\u0046\u0047' +
	'\u0048\u0049\u004A\u004B\u004C\u004D\u004E\u004F' +
	'\u0050\u0051\u0052\u0053\u0054\u0055\u0056\u0057' +
	'\u0058\u0059\u005A\u005B\u005C\u005D\u005E\u005F' +
	'\u0060\u0061\u0062\u0063\u0064\u0065\u0066\u0067' +
	'\u0068\u0069\u006A\u006B\u006C\u006D\u006E\u006F' +
	'\u0070\u0071\u0072\u0073\u0074\u0075\u0076\u0077' +
	'\u0078\u0079\u007A\u007B\u007C\u007D\u007E\u007F' +
	'\u20AC\u0020\u201A\u0192\u201E\u2026\u2020\u2021' +
	'\u02C6\u2030\u0160\u2039\u0152\u0020\u017D\u0020' +
	'\u0020\u2018\u2019\u201C\u201D\u2022\u2013\u2014' +
	'\u02DC\u2122\u0161\u203A\u0153\u0020\u017E\u0178' +
	'\u00A0\u00A1\u00A2\u00A3\u00A4\u00A5\u00A6\u00A7' +
	'\u00A8\u00A9\u00AA\u00AB\u00AC\u00AD\u00AE\u00AF' +
	'\u00B0\u00B1\u00B2\u00B3\u00B4\u00B5\u00B6\u00B7' +
	'\u00B8\u00B9\u00BA\u00BB\u00BC\u00BD\u00BE\u00BF' +
	'\u00C0\u00C1\u00C2\u00C3\u00C4\u00C5\u00C6\u00C7' +
	'\u00C8\u00C9\u00CA\u00CB\u00CC\u00CD\u00CE\u00CF' +
	'\u00D0\u00D1\u00D2\u00D3\u00D4\u00D5\u00D6\u00D7' +
	'\u00D8\u00D9\u00DA\u00DB\u00DC\u00DD\u00DE\u00DF' +
	'\u00E0\u00E1\u00E2\u00E3\u00E4\u00E5\u00E6\u00E7' +
	'\u00E8\u00E9\u00EA\u00EB\u00EC\u00ED\u00EE\u00EF' +
	'\u00F0\u00F1\u00F2\u00F3\u00F4\u00F5\u00F6\u00F7' +
	'\u00F8\u00F9\u00FA\u00FB\u00FC\u00FD\u00FE\u00FF';

const macintosh =
	'' +
	'\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007' +
	'\u0008\u0009\u000A\u000B\u000C\u000D\u000E\u000F' +
	'\u0010\u2318\u21E7\u2325\u2303\u0015\u0016\u0017' +
	'\u0018\u0019\u001A\u001B\u001C\u001D\u001E\u001F' +
	'\u0020\u0021\u0022\u0023\u0024\u0025\u0026\u0027' +
	'\u0028\u0029\u002A\u002B\u002C\u002D\u002E\u002F' +
	'\u0030\u0031\u0032\u0033\u0034\u0035\u0036\u0037' +
	'\u0038\u0039\u003A\u003B\u003C\u003D\u003E\u003F' +
	'\u0040\u0041\u0042\u0043\u0044\u0045\u0046\u0047' +
	'\u0048\u0049\u004A\u004B\u004C\u004D\u004E\u004F' +
	'\u0050\u0051\u0052\u0053\u0054\u0055\u0056\u0057' +
	'\u0058\u0059\u005A\u005B\u005C\u005D\u005E\u005F' +
	'\u0060\u0061\u0062\u0063\u0064\u0065\u0066\u0067' +
	'\u0068\u0069\u006A\u006B\u006C\u006D\u006E\u006F' +
	'\u0070\u0071\u0072\u0073\u0074\u0075\u0076\u0077' +
	'\u0078\u0079\u007A\u007B\u007C\u007D\u007E\u007F' +
	'\u00C4\u00C5\u00C7\u00C9\u00D1\u00D6\u00DC\u00E1' +
	'\u00E0\u00E2\u00E4\u00E3\u00E5\u00E7\u00E9\u00E8' +
	'\u00EA\u00EB\u00ED\u00EC\u00EE\u00EF\u00F1\u00F3' +
	'\u00F2\u00F4\u00F6\u00F5\u00FA\u00F9\u00FB\u00FC' +
	'\u2020\u00B0\u00A2\u00A3\u00A7\u2022\u00B6\u00DF' +
	'\u00AE\u00A9\u2122\u00B4\u00A8\u2260\u00C6\u00D8' +
	'\u221E\u00B1\u2264\u2265\u00A5\u00B5\u2202\u2211' +
	'\u220F\u03C0\u222B\u00AA\u00BA\u03A9\u00E6\u00F8' +
	'\u00BF\u00A1\u00AC\u221A\u0192\u2248\u2206\u00AB' +
	'\u00BB\u2026\u00A0\u00C0\u00C3\u00D5\u0152\u0153' +
	'\u2013\u2014\u201C\u201D\u2018\u2019\u00F7\u25CA' +
	'\u00FF\u0178\u2044\u20AC\u2039\u203A\uFB01\uFB02' +
	'\u2021\u00B7\u201A\u201E\u2030\u00C2\u00CA\u00C1' +
	'\u00CB\u00C8\u00CD\u00CE\u00CF\u00CC\u00D3\u00D4' +
	'\uF8FF\u00D2\u00DA\u00DB\u00D9\u0131\u02C6\u02DC' +
	'\u00AF\u02D8\u02D9\u02DA\u00B8\u02DD\u02DB\u02C7';

// Spec lists code 0x16 as mapping to U+0017... assumed error and changed to U+0016
// Additionally, 3 characters are undefined and ahve been set to replacement char
const PDFDocEncoding =
	'' +
	'\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007' +
	'\u0008\u0009\u000A\u000B\u000C\u000D\u000E\u000F' +
	'\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017' +
	'\u02D8\u02C7\u02C6\u02D9\u02DD\u02DB\u02DA\u02DC' +
	'\u0020\u0021\u0022\u0023\u0024\u0025\u0026\u0027' +
	'\u0028\u0029\u002A\u002B\u002C\u002D\u002E\u002F' +
	'\u0030\u0031\u0032\u0033\u0034\u0035\u0036\u0037' +
	'\u0038\u0039\u003A\u003B\u003C\u003D\u003E\u003F' +
	'\u0040\u0041\u0042\u0043\u0044\u0045\u0046\u0047' +
	'\u0048\u0049\u004A\u004B\u004C\u004D\u004E\u004F' +
	'\u0050\u0051\u0052\u0053\u0054\u0055\u0056\u0057' +
	'\u0058\u0059\u005A\u005B\u005C\u005D\u005E\u005F' +
	'\u0060\u0061\u0062\u0063\u0064\u0065\u0066\u0067' +
	'\u0068\u0069\u006A\u006B\u006C\u006D\u006E\u006F' +
	'\u0070\u0071\u0072\u0073\u0074\u0075\u0076\u0077' +
	'\u0078\u0079\u007A\u007B\u007C\u007D\u007E\uFFFD' +
	'\u2022\u2020\u2021\u2026\u2014\u2013\u0192\u2044' +
	'\u2039\u203A\u2212\u2030\u201E\u201C\u201D\u2018' +
	'\u2019\u201A\u2122\uFB01\uFB02\u0141\u0152\u0160' +
	'\u0178\u017D\u0131\u0142\u0153\u0161\u017E\uFFFD' +
	'\u20AC\u00A1\u00A2\u00A3\u00A4\u00A5\u00A6\u00A7' +
	'\u00A8\u00A9\u00AA\u00AB\u00AC\uFFFD\u00AE\u00AF' +
	'\u00B0\u00B1\u00B2\u00B3\u00B4\u00B5\u00B6\u00B7' +
	'\u00B8\u00B9\u00BA\u00BB\u00BC\u00BD\u00BE\u00BF' +
	'\u00C0\u00C1\u00C2\u00C3\u00C4\u00C5\u00C6\u00C7' +
	'\u00C8\u00C9\u00CA\u00CB\u00CC\u00CD\u00CE\u00CF' +
	'\u00D0\u00D1\u00D2\u00D3\u00D4\u00D5\u00D6\u00D7' +
	'\u00D8\u00D9\u00DA\u00DB\u00DC\u00DD\u00DE\u00DF' +
	'\u00E0\u00E1\u00E2\u00E3\u00E4\u00E5\u00E6\u00E7' +
	'\u00E8\u00E9\u00EA\u00EB\u00EC\u00ED\u00EE\u00EF' +
	'\u00F0\u00F1\u00F2\u00F3\u00F4\u00F5\u00F6\u00F7' +
	'\u00F8\u00F9\u00FA\u00FB\u00FC\u00FD\u00FE\u00FF';

// Custom 437 handling because node-iconv & iconv-lite fail on low bytes
export const customMappingsStr = {
	cp437: cp437,
	cp1252: cp1252,
	macintosh: macintosh,
	pdfdoc: PDFDocEncoding,
} as const;

// Custom 437 handling because node-iconv & iconv-lite fail on low bytes
export const customMappings = {
	cp437: Buffer.from(cp437, 'utf16le'),
	cp1252: Buffer.from(cp1252, 'utf16le'),
	macintosh: Buffer.from(macintosh, 'utf16le'),
	pdfdoc: Buffer.from(PDFDocEncoding, 'utf16le'),
} as const;

export type NativeEnc = keyof typeof customMappings;
